import React from 'react';
import DsButton from '../../DsButton';
import { useChatTopicsContext } from './ChatTopicsContext';
import { topicOfMessage } from './useChatTopics';

export function ChatTopicButton() {
  const topics = useChatTopicsContext();
  if (!topics?.enabled) return null;
  if (topics.selection?.active) return null;
  return (
    <DsButton variant="ghost" size="sm" icon className="chat-header-icon-button chat-topic-button"
      onClick={topics.openPicker} title="スレッドを選択・作成" aria-label="スレッドを選択・作成" aria-haspopup="dialog">
      <i className="fa-solid fa-list-check" aria-hidden="true" />
      {topics.rows.some((topic: any) => topic.unreadCount > 0) && <span className="chat-topic-dot" aria-label="未読のスレッドあり" />}
    </DsButton>
  );
}
export function ChatTopicHeading() {
  const topics = useChatTopicsContext();
  if (!topics?.enabled) return null;
  const selection = topics.selection;
  return <>
    {selection?.active && <div className="chat-topic-selection-bar" role="region" aria-label="メッセージの選択">
      <span>{selection.rows.length}件</span>
      <DsButton variant="ghost" size="sm" disabled={selection.busy || !selection.rows.length} onClick={() => { void selection.copy(); }}>
        <i className="fa-regular fa-copy" aria-hidden="true" />まとめてコピー
      </DsButton>
      <DsButton variant="ghost" size="sm" disabled={selection.busy || !selection.rows.length} onClick={() => {
        if (topics.topicId) void selection.execute().catch(() => {}); else selection.openPicker();
      }}><i className="fa-solid fa-list-check" aria-hidden="true" />{topics.topicId ? 'スレッドから外す' : 'スレッドに追加'}</DsButton>
      <DsButton variant="ghost" size="sm" disabled={selection.busy} onClick={selection.finish}>終了</DsButton>
      {selection.notice && <span role="status">{selection.notice}</span>}
      {selection.error && <span role="alert">{selection.error}</span>}
    </div>}
    {topics.selected && <div className="chat-topic-heading">
      <i className="fa-solid fa-list-check" aria-hidden="true" />
      <h2 title={topics.selected.name}>{topics.selected.name}</h2>
      <DsButton variant="ghost" size="sm" icon onClick={() => topics.selectTopic(null)}
        aria-label="すべてのメッセージに戻る" title="スレッドを解除">
        <i className="fa-solid fa-xmark" aria-hidden="true" />
      </DsButton>
    </div>}
  </>;
}
export function ChatMessageTopicLabel({ message }: { message: any }) {
  const topics = useChatTopicsContext();
  const topic = topicOfMessage(message);
  if (!topic || topics?.selected || topics?.selection?.active) return null;
  return <DsButton variant="ghost" size="sm" className="chat-message-topic-label" onClick={(event: React.MouseEvent) => { event.stopPropagation(); topics?.selectTopic(topic); }} aria-label={`${topic.name}のスレッドを開く`}>{topic.name}</DsButton>;
}
